export default __webpack_public_path__ + "static/media/yellow-daisie.1af980b1.jpg";